import { deleteRestRequest } from '../../../helpers/RestHelpers'
import { api } from '../../../configuration'

type FeedbacksResponse = {
  status?: boolean
}

export type DeleteFeedbackParams = {
  feedback: string | number
}

const deleteFeedback = ({ feedback, ...data }: DeleteFeedbackParams) =>
  deleteRestRequest({
    url: api.REST_API_URL + `/feedbacks/${feedback}`,
    data: {
      data,
    },
    transformer: (response: FeedbacksResponse): boolean => {
      return !!response?.status
    },
  })

export default deleteFeedback
